import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { getText } = useLanguage();

  // Contraseña para acceder a la sección English (puedes cambiarla)
  const CORRECT_PASSWORD = 'english2025';

  useEffect(() => {
    // Verificar si ya está autenticado en la sesión
    const authStatus = sessionStorage.getItem('englishAuth');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem('englishAuth', 'true');
      setError('');
    } else {
      setError(getText('auth.incorrectPassword'));
      setPassword('');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem('englishAuth');
    setPassword('');
  };

  if (isAuthenticated) {
    return (
      <div className="protected-content">
        <div className="logout-header">
          <button onClick={handleLogout} className="logout-btn">
            🔒 {getText('auth.logoutButton')}
          </button>
        </div>
        {children}
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>🔐 {getText('auth.title')}</h2>
          <p>{getText('auth.subtitle')}</p>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="password">{getText('auth.passwordLabel')}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={getText('auth.passwordPlaceholder')}
              required
              autoFocus
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="auth-submit-btn">
            {getText('auth.submitButton')}
          </button>
        </form>
        <div className="auth-footer">
          <p>💡 {getText('auth.privateSection')}</p>
        </div>
      </div>
    </div>
  );
};

export default ProtectedRoute;
